import React from 'react'
import { QueryClientProvider, QueryClient } from 'react-query'
import { ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import theme from './theme'
import Router from './router'
import { BalanceProvider } from './stateManagement/Provider'

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BalanceProvider>
          <Router />
        </BalanceProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}

export default App
